export default {
  path: '/scout',
  name: 'Scout',
  redirect: '/scout/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    /* 球探列表 */
    {
      path: 'list',
      name: 'ScoutList',
      component: () => import('@/views/scout'),
      meta: { requiresAuth: true }
    },
    /* 添加球探 */
    {
      path: 'add',
      name: "ScoutAdd",
      component: () => import('@/views/scout/addScout'),
      meta: { requiresAuth: true }
    },
    /* 五环评价 */
    {
      path: 'rate',
      name: "ScoutRate",
      component: () => import('@/views/scout/scoutRate'),
      meta: { requiresAuth: true }
    },
    /* 主观评价 */
    {
      path: 'comment',
      name: "CommentScout",
      component: () => import("@/views/scout/comment"),
      meta: { requiresAuth: true }
    },
    /* 球探报告详细信息 */
    {
      path: 'details',
      name: 'ScoutDetails',
      component: () => import("@/views/scout/details"),
      meta: { requiresAuth: true }
    },
    /* 球探报告详细信息编辑 */
    {
      path: 'editInfo',
      name: "EditInfo",
      component: () => import("@/views/scout/edit/infoEdit"),
      meta: { requiresAuth: true }
    },
    /* 球探评分编辑 */
    {
      path: 'editRate',
      name: 'EditRate',
      component: () => import("@/views/scout/edit/rateEdit"),
      meta: { requiresAuth: true }
    },
    /* 球探综合评价 编辑 */
    {
      path: 'editComment',
      name: 'EditComment',
      component: () => import("@/views/scout/edit/commentEdit"),
      meta: { requiresAuth: true}
    }
  ]
}
